export default function toLoggedInUser(user) {
  if (!user) return null;

  return {
    id: user.id,
    name: user.billingName || `${user.lastName} ${user.firstName}`,
    email: user.email,
    roles: user.roles,
  };
}
